module.exports = require('./dist/lib/runtime-config')
